import axios from 'axios'
import {useQuery} from 'react-query'
import {API_URL} from '../../../../../../_metronic/helpers'
import {
  InvoiceAutoSendSetting,
  resolveInvoiceAutoSendDefault,
} from './invoiceAutoSend'

const getInvoiceAutoSendSettings = () =>
  axios
    .get<InvoiceAutoSendSetting[]>(`${API_URL}/invoices/autoSendSettings`)
    .then((response) => response.data)

export const useInvoiceAutoSendDefault = (
  entryType: number,
  companyId: number | undefined
) => {
  const query = useQuery(
    ['invoice-auto-send-settings', companyId],
    getInvoiceAutoSendSettings,
    {
      enabled: !!companyId,
      staleTime: 5 * 60 * 1000,
    }
  )

  return {
    defaultAutoSend: resolveInvoiceAutoSendDefault(query.data, entryType),
    isLoading: query.isLoading,
  }
}
